import { Vue } from 'vue-property-decorator'

export const invoiceSettlementType = () => {
  return {
    EXEMPTION: { key: 50380001, label: Vue.prototype.$gettext('INVOICE_SETTLEMENT_TYPE.50380001') },
    TOTAL_WRITE_OFF: { key: 50380002, label: Vue.prototype.$gettext('INVOICE_SETTLEMENT_TYPE.50380002') },
    PARTIAL_WRITE_OFF: { key: 50380003, label: Vue.prototype.$gettext('INVOICE_SETTLEMENT_TYPE.50380003') },
    PARTIAL_LOSS: { key: 50380004, label: Vue.prototype.$gettext('INVOICE_SETTLEMENT_TYPE.50380004') },
    TOTAL_LOSS: { key: 50380005, label: Vue.prototype.$gettext('INVOICE_SETTLEMENT_TYPE.50380005') },
    UPDATE: { key: 50380006, label: Vue.prototype.$gettext('INVOICE_SETTLEMENT_TYPE.50380006') }
  }
}
